// @flow

import React from 'react';
import Pill from 'shared/components/common/Pill';
import { i18n } from 'shared/utils';

type Props = {
  status: string,
  width?: number,
};

const STATUS_COLORS = {
  REQUESTED: 'orange',
  AUTHORIZED: 'blue',
  RECEIVED: 'green',
  CLOSED: 'grey',
  REJECTED: 'red',
};

const STATUS_LABELS = {
  REQUESTED: 'Requested',
  AUTHORIZED: 'Authorized',
  RECEIVED: 'Received',
  CLOSED: 'Closed',
  REJECTED: 'Rejected',
};

const ReturnOrderStatusPill = ({ status, width }: Props) => (
  <Pill color={STATUS_COLORS[status] || 'grey'} width={width}>
    {i18n.t(STATUS_LABELS[status] || status)}
  </Pill>
);

export default ReturnOrderStatusPill;
